import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const Reports = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (reportPath) => {
    navigate(reportPath);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box marginLeft={theme.spacing(2)}>
      <Button onClick={handleMenuClick} sx={{ display: { xs: 'none', sm: 'block' }, textTransform: 'none' }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <FolderIcon sx={{ color: 'primary.main' }} />
          <Typography variant="h3" sx={{ color: 'primary.main' }}>
            <b>Reports</b>
          </Typography>
        </Stack>
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleMenuItemClick('/app/reports')}>All Reports</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report1_1')}>Report 1.1</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report1_2')}>Report 1.2</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report2')}>Report 2</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report3')}>Report 3</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report4')}>Report 4</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report5')}>Report 5</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report6')}>Report 6</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/app/report7')}>Report 7</MenuItem>
      </Menu>
    </Box>
  );
};

export default Reports;
